import { render, staticRenderFns } from "./HistoryModel.vue?vue&type=template&id=fe10a424"
import script from "./HistoryModel.vue?vue&type=script&lang=js"
export * from "./HistoryModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports